import { gqlRequest } from './api';

export const productService = {
  async searchProducts({ page = 1, limit = 10, phrase, sources, manufacturers, categories, availabilities, tags } = {}) {
    const data = await gqlRequest(`
      query SearchProducts(
        $page: Int, $limit: Int, $phrase: String,
        $sources: [String!], $manufacturers: [String!],
        $categories: [String!], $availabilities: [String!], $tags: [String!]
      ) {
        searchProducts(
          page: $page, limit: $limit, phrase: $phrase,
          sources: $sources, manufacturers: $manufacturers,
          categories: $categories, availabilities: $availabilities, tags: $tags
        ) {
          resultCount
          hits {
            id
            sku
            title
            source
            packaging
            description
            isActive
            availability
            thumbnailUrl
            price { price specialPrice }
            gallery
            categories
            requiredLicense
            subscriptions { id name frequency occurrences }
          }
        }
      }
    `, { page, limit, phrase, sources, manufacturers, categories, availabilities, tags });

    return data.searchProducts;
  },

  async getProductsById(ids) {
    const data = await gqlRequest(`
      query ProductsById($ids: [String!]!) {
        productsById(ids: $ids) {
          id
          sku
          title
          source
          packaging
          description
          isActive
          availability
          thumbnailUrl
          price { price specialPrice }
          gallery
          categories
          requiredLicense
        }
      }
    `, { ids });

    return data.productsById;
  },

  async getProductDetails(id) {
    const data = await gqlRequest(`
      query ProductDetails($id: String!) {
        productDetails(id: $id) {
          product {
            id
            sku
            title
            source
            sourceUrl
            packaging
            description
            descriptionRichText
            isActive
            availability
            thumbnailUrl
            price { price specialPrice }
            gallery
            categories
            requiredLicense
            variants { id sku title price { price specialPrice } availability }
            subscriptions { id name frequency occurrences }
          }
        }
      }
    `, { id });

    return data.productDetails?.product;
  },

  async unifiedSearch({ page = 1, limit = 10, phrase, sources, manufacturers, categories, availabilities, tags, frequency } = {}) {
    const data = await gqlRequest(`
      query UnifiedSearch(
        $page: Int, $limit: Int, $phrase: String,
        $sources: [String!], $manufacturers: [String!],
        $categories: [String!], $availabilities: [String!],
        $tags: [String!], $frequency: Int
      ) {
        unifiedSearch(
          page: $page, limit: $limit, phrase: $phrase,
          sources: $sources, manufacturers: $manufacturers,
          categories: $categories, availabilities: $availabilities,
          tags: $tags, frequency: $frequency
        ) {
          resultCount
          hits {
            ... on Product {
              id sku title source packaging description
              isActive availability thumbnailUrl
              price { price specialPrice }
              gallery categories requiredLicense
            }
            ... on Subscription {
              id name frequency occurrences
              products { quantity product { id sku title price { price } } }
            }
          }
        }
      }
    `, { page, limit, phrase, sources, manufacturers, categories, availabilities, tags, frequency });

    return data.unifiedSearch;
  },

  async getProductSample() {
    const data = await gqlRequest(`
      query ProductSample {
        productSample {
          id sku title source packaging description
          isActive availability thumbnailUrl
          price { price specialPrice }
          gallery categories requiredLicense
        }
      }
    `);

    return data.productSample;
  }
};
